import { TIChartPointModel } from "../../models/data-point/ti-chart-point.model";
import { HighChartDataPoints } from "../../models/data-point/highchart-data-points.model";

export class TIDataPointToHighChartVolumeDataPointMapper {
    public static map(rawData: Array<TIChartPointModel>): HighChartDataPoints {
        const dataPoints: Array<any> = [];
        const dataPointsZone: Array<any> = [];
        for (const data of rawData) {
            dataPoints.push(TIDataPointToHighChartVolumeDataPointMapper.toHighChartDataPoint(data));
        }

        return new HighChartDataPoints({
            points: dataPoints,
            zones: dataPointsZone
        });
    }

    public static toHighChartDataPoint(point: TIChartPointModel): any {
        return { x: point.xValue, y: point.volume };
    }
}